// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import './modules/firebase/firebaseInit'
import VueMoment from 'vue-moment'
import VeeValidate from 'vee-validate'
import { store } from './store'
import router from './router'
import shared from './mixins/shared'
import 'vuetify/dist/vuetify.min.css'
// Vue.use(Vuetify)
Vue.use(VeeValidate)
Vue.use(VueMoment)
Vue.config.productionTip = false
Vue.mixin(shared)
Vue.use(Vuetify, {
  theme: {
    primary: '#bacf19',
    secondary: '#484545',
    accent: '#bacf19',
    error: '#c50f0f'
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  created () {
    this.$fb.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$db.collection('userMeta').doc(user.uid).get().then((doc) => {
          this.loading = false
          if (doc.data().approved) {
            let newUser = {
              'id': user.uid,
              'firstName': doc.data().firstName,
              'lastName': doc.data().lastName,
              'email': doc.data().email,
              'telephone': doc.data().telephone,
              'role': doc.data().role,
              'address1': doc.data().address1,
              'address2': doc.data().address2,
              'town': doc.data().town,
              'county': doc.data().county,
              'postcode': doc.data().postcode
            }
            this.$store.dispatch('signUserIn', newUser)
          } else {
            this.$fb.auth().signOut()
            this.$store.dispatch('logout')
            this.$router.push('/')
          }
        }).catch(error => {
          console.log(error)
          this.loading = false
          this.$fb.auth().signOut()
          this.$store.dispatch('logout')
          this.$router.push('/')
        })
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js